import React from 'react';
import GoogleMapReact from 'google-map-react';
import {
	MDBRow as Row,
	MDBCol as Col,
	MDBContainer as Container,
	MDBIcon as Icon
} from 'mdbreact';

const Contact = () => {
	const center = {
		lat: 14.628518,
		lng: 121.048054
	};
	const zoom = 16;
	const Marker = ({ text }) => (
		<Icon className='red-text' icon='map-marker-alt' size='3x' />
	);
	return (
		<section id='contact' className='position-relative mb-5'>
			<Container>
				<Row>
					<Col>
						<h1
							data-aos='fade-up'
							data-aos-delay='50'
							style={{ color: '#059E03' }}
							className='h1-responsive font-weight-bold mt-5 text-center text-uppercase'>
							Suki usap tayo!
						</h1>
						<p
							data-aos='fade-up'
							data-aos-delay='200'
							className='lead grey-text w-responsive mx-auto text-center mx-2'>
							Looking for a supplier for your food and beverage business? <br />
							For questions & inquiries kindly reach out to us through the
							following
						</p>
					</Col>
				</Row>
				<Row className='text-center my-5 p-4 d-flex'>
					<Col md='4' className='text-center align-self-center'>
						<ul className='list-unstyled mb-0 d-inline-block'>
							<li data-aos='fade-right' data-aos-delay='350'>
								<Icon
									style={{ color: '#FF6701' }}
									icon='map-marker-alt'
									size='2x'
								/>
								<p>
									{' '}
									0121 Ermin Garcia Avenue, <br />
									Brgy. E. Rodriguez, Cubao, Quezon City
								</p>
							</li>
							<li data-aos='fade-right' data-aos-delay='500'>
								<Icon
									style={{ color: '#FF6701' }}
									icon='phone'
									size='2x'
									className='mt-4'
								/>
								<p>7901-1712</p>
							</li>
							<li data-aos='fade-right' data-aos-delay='650'>
								<Icon
									style={{ color: '#FF6701' }}
									icon='envelope'
									size='2x'
									className='mt-4'
								/>
								<p className='m-0'>mail@megaqmart.com</p>
							</li>
						</ul>
					</Col>
					<Col
						data-aos='fade-left'
						data-aos-delay='700'
						md='8'
						className='align-self-center'>
						<div style={{ height: '60vh', width: '100%' }} className='mt-5'>
							<GoogleMapReact
								bootstrapURLKeys={{
									key: 'AIzaSyDCxt_3-4uIBGsvkqRZWYsCyr89goV8TNw'
								}}
								defaultCenter={center}
								defaultZoom={zoom}>
								<Marker lat={14.628518} lng={121.048054} text='My Marker' />
							</GoogleMapReact>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default Contact;
